enum ProductionNonConformityStatus {
    Untreated = 0,
    Resolved = 1,
    ImpossibleToResolve = 2,
    NotWorthSolving = 3
}

export default ProductionNonConformityStatus;